import { render } from "./UploadImages.vue?vue&type=template&id=3a852616&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"

import "./UploadImages.vue?vue&type=style&index=0&id=3a852616&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a852616"]])

export default __exports__